<script lang="ts">
	import SubscriptionSetupStep from "@components/SubscriptionSetupStep.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { getHowItWorksAnchor } from "@core/schema/paths/getHowItWorksAnchor.js";
	import { idFromAnchor } from "@core/schema/utils/idFromAnchor.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./FathersClubHowItWorksSection.translations.json" with { type: "json" };

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
	const id = idFromAnchor(getHowItWorksAnchor(tenant.locale));
</script>

<section class="py-11 full-width grid-container bg-fcrbeige [counter-reset:how-it-works]" {id}>
	<div class="mb-9 text-center uppercase text-fcrorange container-6 font-bold tracking-[.1em]">
		<Formatted text={translate("section")} />
	</div>
	<Heading
		level={2}
		text={translate("title")}
		class={["font-antipol font-medium text-8/tighter text-fcrdarkgray mb-4", "mx-auto text-center max-w-150"]}
	/>
	<SubscriptionSetupStep
		title={translate("stepOneTitle")}
		description={translate("stepOneDescription")}
		class="bg-fcramber container-start-1 md:container-end-6 lg:container-end-4"
	/>
	<SubscriptionSetupStep
		title={translate("stepTwoTitle")}
		description={translate("stepTwoDescription")}
		class={["bg-fcrtan", "md:container-start-7 lg:container-start-5 lg:container-end-8"]}
	/>
	<SubscriptionSetupStep
		title={translate("stepThreeTitle")}
		description={translate("stepThreeDescription")}
		class="bg-fcrslate md:container-6 lg:container-start-9 lg:container-end-12"
	/>
	<p class="mt-4 text-fcrgray text-center [font-feature-settings:'cv11'_1,'cv13'_1]">
		<Formatted text={translate("membership")} />
	</p>
</section>
